// extracted by mini-css-extract-plugin
export default {"section":"styles_section__E9faE","narrowField":"styles_narrowField__ujZUj","hint":"styles_hint__yughx","footer":"styles_footer__NX-Xn"};